import './MovieList.css';

import moment from 'moment';
import * as React from 'react';
import { adopt } from 'react-adopt';
import { Mutation, Query } from 'react-apollo';
import Infinite from 'react-infinite';
import InfiniteScroll from 'react-infinite-scroller';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import addMovieToListUpdate from 'src/cache/addMovieToList';
import deleteMovieFromListUpdate from 'src/cache/deleteMovieFromList';
import Tabs from 'src/components/Tabs';
import ADD_MOVIE_TO_LIST from 'src/mutations/addMovieToList';
import DELETE_MOVIE_FROM_LIST from 'src/mutations/deleteMovieFromList';
import listMutationsOptimisticResponse from 'src/mutations/listMutationOptimisticResponse';

import MovieCard from '../components/MovieCard';
import GET_MOVIE_LIST from '../queries/getMovieList';

export class MovieListContainer extends React.Component<
  RouteComponentProps,
  {}
> {
  public render() {
    const { user, userProfile, movieListId, locationPath } = this.props;

    return (
      <div className="movie-list">
        <div className="ui grid">
          <div className="ten centered wide column">
            {this.props.iconTitle && (
              <div className="movie-list-title">
                <i className={`${this.props.iconTitle} icon`} />
              </div>
            )}
            <MovieListCompose
              locationPath={locationPath}
              user={user}
              userProfile={userProfile}
              movieListId={movieListId}
            />
          </div>
        </div>
      </div>
    );
  }
}

const MovieList = ({
  getMovieList,
  user,
  userProfile,
  tabs,
  addMovieToList,
  deleteMovieFromList,
}) =>
  (getMovieList.data && getMovieList.data.movieList && (
    <InfiniteScroll
      pageStart={0}
      loadMore={loadMore.bind(this, getMovieList.fetchMore, getMovieList.data)}
      hasMore={
        getMovieList.data.movieList.page < getMovieList.data.movieList.pageCount
      }
      loader={
        <div className="loader" key={0}>
          Loading ...
        </div>
      }
    >
      <Infinite useWindowAsScrollContainer={true} elementHeight={187}>
        {getMovieList.data.movieList.items.map((movie, i) => (
          <MovieCard
            addMovieToList={addMovieToList}
            deleteMovieFromList={deleteMovieFromList}
            listMutationsOptimisticResponse={listMutationsOptimisticResponse}
            key={movie.id}
            directors={movie.directors}
            movieId={movie.id}
            poster={movie.poster}
            releaseDate={
              movie.displayReleaseDate && movie.displayReleaseDate.date
            }
            title={movie.title}
            runtime={movie.runtime}
            userProfile={userProfile}
          />
        ))}
      </Infinite>
    </InfiniteScroll>
  )) ||
  null;

const loadMore = (fetchMore, data) =>
  fetchMore({
    updateQuery: (prev, { fetchMoreResult }) => {
      if (fetchMoreResult.movieList.items.length === 0) {
        return prev;
      }
      return {
        movieList: {
          ...fetchMoreResult.movieList,
          items: [...prev.movieList.items, ...fetchMoreResult.movieList.items],
        },
      };
    },
    variables: {
      page: data && data.movieList && data.movieList.page + 1,
    },
  });

const Compose = adopt({
  tabs: ({ render, locationPath }) => (
    <Tabs locationPath={locationPath} tabs={["upcoming", "released"]}>
      {render}
    </Tabs>
  ),
  // tslint:disable-next-line:object-literal-sort-keys
  getMovieList: ({ render, movieListId, tabs }) => (
    <Query
      query={GET_MOVIE_LIST}
      variables={{
        filter: tabs.currentTab,
        id: movieListId,
        userUtcOffset: `${moment().utcOffset()}`,
      }}
    >
      {render}
    </Query>
  ),
  addMovieToList: ({ render, userProfile }) => (
    <Mutation
      mutation={ADD_MOVIE_TO_LIST}
      update={addMovieToListUpdate({ userProfile }) as any}
    >
      {(mutation, result) => render({ mutation, result })}
    </Mutation>
  ),
  deleteMovieFromList: ({ render, userProfile, tabs }) => (
    <Mutation
      mutation={DELETE_MOVIE_FROM_LIST}
      update={
        deleteMovieFromListUpdate({
          filter: tabs.currentTab,
          userProfile,
        }) as any
      }
    >
      {(mutation, result) => render({ mutation, result })}
    </Mutation>
  ),
});

const MovieListCompose = (props) => (
  <Compose {...props}>
    {({ addMovieToList, deleteMovieFromList, getMovieList, tabs }) => (
      <MovieList
        addMovieToList={addMovieToList}
        deleteMovieFromList={deleteMovieFromList}
        getMovieList={getMovieList}
        tabs={tabs}
        {...props}
      />
    )}
  </Compose>
);

export default withRouter(MovieListContainer);



// WEBPACK FOOTER //
// ./src/containers/MovieList.tsx